import { IOffersDashboardFilterOptions } from '@/store/offers-dashboard/types';
import { IRegionConfigsState } from '@/store/region_config_dashboard/types';
import { uiTypes } from 'shared-components';
import { FilterGroup, IAgent, IProgrammableTag, ISystemAndUniConfig } from 'types';
import { getEngagementGroupFilters } from './engagement';
import { getOffersGroupFilterGroup } from './offers';
import { getOtherGroupFilters } from './other';
import { getStudentsFilterGroup } from './students';
import { TableRow } from '@/components/organisms/ApplyDataGrid/table/types';

export interface IGetFilterGroupsProps {
  activeFilters: {
    [key: string]: string[];
  };
  agents?: IAgent[];
  regionConfigs?: IRegionConfigsState;
  config?: ISystemAndUniConfig;
  isPathway?: boolean;
  programmableTags?: IProgrammableTag[];
  userRole?: uiTypes.UserRole;
  rows?: TableRow[];
  filterOptions?: IOffersDashboardFilterOptions;
}

export const getFilterGroups = (props: IGetFilterGroupsProps): FilterGroup[] => {
  return [
    getStudentsFilterGroup(props),
    getOffersGroupFilterGroup(props),
    getEngagementGroupFilters(props),
    getOtherGroupFilters(props),
  ];
};
